import { InformationCircleIcon } from "@heroicons/react/24/outline"
import React from "react"

type TooltipProps = {
  title?: string
  items: string[]
  position?: "top" | "bottom" | "left" | "right"
  children?: React.ReactNode
  widthClass?: string
}

const positionClasses: Record<string, string> = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  items,
  position = "top",
  children,
  widthClass = "w-64",
}) => {
  return (
    <div className="relative group inline-flex items-center">
      {children ? (
        children
      ) : (<InformationCircleIcon
                // className="w-4 h-4 text-slate-400 hover:text-blue-600 cursor-pointer"
                 className="w-4 h-4 text-slate-500 cursor-pointer inline"
              />)}

      <div
        className={`
          absolute
          ${positionClasses[position]}
          ${widthClass}
          rounded-md
          bg-white dark:bg-slate-800
          border border-slate-200 dark:border-slate-700
          p-3 text-xs
          text-slate-700 dark:text-slate-200
          shadow-lg
          opacity-0 invisible
          group-hover:opacity-100 group-hover:visible
          transition-all duration-150
          z-50
        `}
      >
        {title && (
          <p className="font-semibold mb-1">
            {title}
          </p>
        )}

        <ul className="space-y-1">
          {items.map((item, idx) => (
            <li key={idx} className="flex gap-1">
              <span>•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Tooltip
